export default "__VITE_ASSET__C25lDhsE__"